// Types for Plausible and GA4
interface PlausibleWindow extends Window {
  plausible?: (eventName: string, options?: { props?: Record<string, unknown> }) => void;
}

declare const window: PlausibleWindow;

interface GA4Window extends Window {
  gtag?: (command: string, eventName: string, params?: Record<string, unknown>) => void;
  dataLayer?: unknown[];
}

// Check if analytics consent is given
function isAnalyticsConsented(): boolean {
  try {
    const consent = JSON.parse(localStorage.getItem('koji_cookie_consent') || '{}');
    return consent.analytics === true;
  } catch {
    return false;
  }
}

// Track event to Plausible (always, no cookies needed)
export function trackPlausible(eventName: string, properties?: Record<string, unknown>) {
  if (typeof window !== 'undefined' && window.plausible) {
    window.plausible(eventName, { props: properties });
  }
}

// Track event to GA4 (only if consented)
export function trackGA4(eventName: string, properties?: Record<string, unknown>) {
  if (typeof window !== 'undefined' && isAnalyticsConsented()) {
    const w = window as GA4Window;
    if (w.gtag) {
      w.gtag('event', eventName, properties);
    }
  }
}

// Track event to both
export function trackEvent(eventName: string, properties?: Record<string, unknown>) {
  trackPlausible(eventName, properties);
  trackGA4(eventName, properties);
}

// Track page view
export function trackPageView(path: string) {
  trackPlausible('pageview', { path });
  trackGA4('page_view', { page_path: path });
}

// Predefined events for Koji funnel
export const AnalyticsEvents = {
  PAGE_VIEW: 'page_view',
  SIGNUP_STARTED: 'signup_started',
  SIGNUP_COMPLETED: 'signup_completed',
  PLAN_SELECTED: 'plan_selected',
  CHECKOUT_INITIATED: 'checkout_initiated',
  CHECKOUT_COMPLETED: 'checkout_completed',
  SNIPPET_INSTALLED: 'snippet_installed',
  EXPERIMENT_CREATED: 'experiment_created',
  SUGGESTION_APPROVED: 'suggestion_approved',
  CHAT_MESSAGE_SENT: 'chat_message_sent',
  ONBOARDING_COMPLETED: 'onboarding_completed',
} as const;
